module.exports = __webpack_public_path__ + "img/13_17.d20d53c6.png";